var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26.002,
    viewBox: "0 0 26 26.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002c5f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20175",
    "data-name": "Group 20175",
    transform: "translate(-927 -911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9856",
    "data-name": "Path 9856",
    className: "cls-1",
    d: "M285.75,151.541a1.509,1.509,0,0,1,2.134,2.134l-11.275,11.276a1.509,1.509,0,0,1-2.134,0l-4.272-4.272a1.508,1.508,0,0,1,2.133-2.133l3.205,3.205,10.209-10.21Z",
    transform: "translate(664.162 763.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9857",
    "data-name": "Path 9857",
    className: "cls-1",
    d: "M201.317,120.824a1.505,1.505,0,0,1,3.007-.154,12.91,12.91,0,0,1-1.338,6.439,1.485,1.485,0,0,1-.139.275,12.993,12.993,0,0,1-17.274,5.6,1.556,1.556,0,0,1-.279-.142,12.993,12.993,0,0,1-5.6-17.276,1.5,1.5,0,0,1,.14-.275,12.992,12.992,0,0,1,17.417-5.528,1.5,1.5,0,0,1-1.367,2.677,10,10,0,0,0-13.433,4.334l-.01.019a10,10,0,0,0,4.317,13.424l.035.018A10,10,0,0,0,200.23,125.9l.009-.019a10.075,10.075,0,0,0,1.078-5.057Z",
    transform: "translate(748.659 802.666)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.685aaa251dbc3aceaeb0e3c09e26f423.svg";
export { ForwardRef as ReactComponent };